import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.66663 2.66667C2.66663 2.29848 2.9651 2 3.33329 2H5.99996C6.36815 2 6.66663 2.29848 6.66663 2.66667V13.3333C6.66663 13.7015 6.36815 14 5.99996 14H3.33329C2.9651 14 2.66663 13.7015 2.66663 13.3333V2.66667Z",
		fill: "#312E81"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.33325 2.66667C9.33325 2.29848 9.63173 2 9.99992 2H12.6666C13.0348 2 13.3333 2.29848 13.3333 2.66667V13.3333C13.3333 13.7015 13.0348 14 12.6666 14H9.99992C9.63173 14 9.33325 13.7015 9.33325 13.3333V2.66667Z",
		fill: "#312E81"
	})]
});
export default SvgIconPause;
